<template>
  <div class="cart_button" id="cart_button_web_copy">
    <p v-if="!product.preorder && product.stock && !inCart">
      <a
        id="buy-in-one-click"
        class="kupit pum-trigger buy-one-click-product"
        style="cursor: pointer"
        @click.stop.prevent="onQuickOrder"
        v-if="!product.preorder && product.stock && !inCart"
      >
        {{ $t('buyOneClick') }}
      </a>
    </p>
    <p v-if="product.stock && !inCart && !product.preorder">
      <button
        type="button"
        name="add-to-cart"
        class="single_add_to_cart_button button alt"
        @click.stop.prevent="onAddToCart"
        v-if="product.stock && !inCart && !product.preorder"
      >
        {{ $t('addToCart') }}
      </button>
    </p>
    <router-link
      id="add-to-cart-button"
      to="/cart"
      class="kupit pum-trigger"
      :title="$t('showCart')"
      v-if="!product.preorder && product.stock && inCart"
    >
      {{ $t('showCart') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CartButtonsWebCopy',
  props: {
    product: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    onQuickOrder: Function,
    onAddToCart: Function,
    inCart: Boolean,
  },
  mounted() {
    let btn = document.querySelector('#cart_button_web_copy')

    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        btn.classList.add('hide')
      } else {
        btn.classList.remove('hide')
      }
    })
  },
}
</script>
